// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"1ecc76fd","455":"762befe4","977":"2bee571a"}[chunkId] + ".chunk.js";
};